export default __webpack_public_path__ + "resources/icons/n132-b561.png";